/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'

import { ExportContainer } from './style'

interface IProps {
    data: any
}

export const ExportButton: React.FC<IProps> = ({ data }) => {
    const [csv, setCsv] = useState<string[]>([`RESOURCE, CODE, NAME, STATUS, DATE`])

    if (data) {
        data.map(str => {
            csv.push(`\n${str.resource}, ${str.bowtieCode}, ${str.bowtieName}, ${str.riskLevelStatus}, ${str.date}`)
        })
    }

    return (
        <ExportContainer>
            <a href="/somefile.txt" download>
                Export to CSV
            </a>
        </ExportContainer>
    )
}
